
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(9(324|391|807)|2(086|096|188)|68(03|38)|(18|74)89|1545|4046|4896|5154|7875)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
